<template>
    <form v-on:submit.prevent="prevent" class="py-12">
        <v-slide-x-transition>
            <v-card class="mx-auto my-3 pa-2" max-width="768" :loading="loading">
                <v-card-title>
                 {{ $t('register.steps.whitelabel.title') }}
                </v-card-title>
                <v-card-subtitle>
                  <div v-html="$t('register.steps.whitelabel.subtitle')"></div>
                </v-card-subtitle>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" md="12" sm="12">
                            <v-text-field debounce="200" :class="subdomainNotAvailable ? '-red--text' : ''" v-model="form.subdomain" :error-messages="subdomainErrors" :label="$t('register.steps.whitelabel.form.subdomain.label')" required solo
                                @input="v$.form.subdomain.$touch()" @blur="v$.form.subdomain.$touch()">
                                <template v-slot:append>
                                  .themediatrade.com
                              </template>
                              <template v-slot:prepend>
                                <v-avatar color="grey" size="22" class="mr-3">
                                  <v-icon dark small>
                                    mdi-lock
                                  </v-icon>
                                </v-avatar>
                                 https://
                            </template>
                           
                              </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                      <!-- <v-col cols="12" md="4" sm="12">
                        <ColorInput :hex="form.config.primaryColor" :label="$t('register.steps.whitelabel.form.primary_color.label')" :errors="primaryColorErrors" @change-color="form.config.primaryColor = $event"></ColorInput>
                      </v-col> -->
                      <!-- <v-col cols="12" md="4" sm="12">
                        

                        <ColorInput :hex="form.config.secondaryColor" :label="$t('register.steps.whitelabel.form.secondary_color.label')" :errors="secondaryColorErrors" @change-color="form.config.secondaryColor = $event"></ColorInput>
                      </v-col> -->
                      <!-- <v-col cols="12" md="4" sm="12">
                        <ColorInput :hex="form.config.textColor" :label="$t('register.steps.whitelabel.form.text_color.label')" :errors="textColorErrors" @change-color="form.config.textColor = $event"></ColorInput>
                      </v-col> -->
                      </v-row>
                      <v-row>
                        <v-col>      
          <v-flex  class="--preview-logo-upload">
            <v-card-title class=" px-0 pt-0 black--text" >{{
                        $t("register.steps.whitelabel.form.logo.label")
                      }}</v-card-title>
                      <div :class=" imgPreview.length ?'imgOK' : '' ">
            <vuetify-upload
              class=".uploadWrapper .border[data-v-428b0bc4] "
              :class="[this.imgPreview >1 ? 'display:none' : '']"
              :max="4"
              can-delete
              accept="image/*"
              :rules="imageRules"
              color="accent"
              v-model="imgPreview"></vuetify-upload>
 
            </div>
          
          </v-flex>
    

     
      </v-col>
                        <!-- <v-col>
                          <div class="title pt-6 " v-html="$t('register.steps.whitelabel.form.logo.label')"></div>
                          <FileUpload :target="`whitelabel/logo/${hash}`" @set-upload="form.logo = $event"></FileUpload>
                        </v-col> -->
                        </v-row>
                        <v-row>
                        <!-- <v-col>
                          <div class="title pt-6 " v-html="$t('register.steps.whitelabel.form.banner.label')"></div>
                          <FileUpload :target="`whitelabel/cover/${hash}`" @set-upload="form.banner = $event"></FileUpload>
                        </v-col> -->
                      </v-row>
                      <!-- <div class="title pt-6 " v-html="$t('register.steps.whitelabel.form.links.label')"></div>
                      <v-alert type="warning" outlined v-if="!form.links.length" @click="addLink()">
                        {{ $t('common.no_links') }}
                      </v-alert>

                        <div v-for="(item, i) in form.links" :key="item.id">
                          <div class="d-flex flex-column flex-md-row" style="width: 100%">
                            <div style="flex: 1 1 100%">
                              <LinkItem :item="item"></LinkItem>
                            </div>
                            <v-btn fab @click="remLink(i)" small color="red" outlined>
                              <v-icon small dark>mdi-trash-can-outline</v-icon>
                            </v-btn>
                          </div>
                        </div>

                      <v-btn color="primary" elevation="0" @click="addLink()">{{ $t('common.add')}}</v-btn> -->
                      <!-- <RocketImage v-if="form.logo && form.logo.length" :logo="form.logo[0].url" :primary-color="form.primaryColor" :secondary-color="form.secondaryColor"></RocketImage> -->
                </v-card-text> 
                
                <v-card-actions class="d-flex justify-end py-3"> 
                    <div class="d-flex justify-end align-center py-2" style="width: 100%">
                        <v-btn class="mr-2 white--text" color="green" elevation="0" type="button"
                        :loading="processing"
                            :disabled="v$.$invalid && v$.$dirty || this.imgPreview.length == 0  || this.imgPreview.length > 1 || this.form.subdomain == ''" @click="submit()">
                            {{ $t('register.steps.buttons.next') }} <v-icon class="ml-6" small>mdi-arrow-right</v-icon>
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-slide-x-transition>
    </form>
</template>
<script>
import useVuelidate from '@vuelidate/core'
import { required, minLength, maxLength} from '@vuelidate/validators'
// import ColorInput from '@/interface/ColorInput.vue'
//import FileUpload from '@/interface/FileUpload.vue'
//import LinkItem from '@/interface/LinkItem.vue'
import moment from 'moment'
// import RocketImage from '@/interface/RocketImage.vue'
export default {
  components: {
    // ColorInput,
    //FileUpload,
   //LinkItem,
    // RocketImage
},
    setup() {
        return { v$: useVuelidate() };
    },
    data: () => ({
      imgPreview:[],
        processing: false,
        loading: false,
        loadingLink: false,
        subdomainNotAvailable: false,
        processingSubdomain: false,
        images:[],
        imageRules: [v => v.length < 2 || "Você pode colocar apenas um logo por vez"],

        form: {
            subdomain: "",
            logo: null,
            //banner: null,
           // links: [],
            config: {
              primaryColor: "#1976D2",
              secondaryColor: "#191592",
              accent: "#191010",
              textColor: "#202020"
            }
        }
    }),
    props: {
        hash: String,
        assets: {
            type: Object,
        },
        country: {
            type: Number
        }
    },


    validations() {
        return {
            form: {
                subdomain: { required, minLength: minLength(2), maxLength: maxLength(20) },
                // config: {
                //   primaryColor: { required },
                //   secondaryColor: { required },
                //   textColor: { required }
                // }
            }
            
        };
    },



    computed: {

      getImgName(){
        
        if(this.imgPreview[0].preview){
          const random = Math.floor(10 + Math.random() * 90);
          const imgId =
        "" +
        (this.$moment().format("X") -
          this.$moment("2015-10", "YYYY-MM").format("X") +
          random);
          return `img/${imgId}.png`
    
        }else{
          return this.imgPreview[0].name
        }
        


      },
        subdomainErrors() {
            const errors = [];
            if (!this.v$.form.subdomain.$dirty)
                return errors;
                this.subdomainNotAvailable && errors.push(this.$t('register.steps.whitelabel.form.subdomain.errors.notAvailable'))
                this.v$.form.subdomain.minLength.$invalid && errors.push(this.$t('register.steps.whitelabel.form.subdomain.errors.min', {count: 6}));
                this.v$.form.subdomain.maxLength.$invalid && errors.push(this.$t('register.steps.whitelabel.form.subdomain.errors.max', {count: 20}));
                this.v$.form.subdomain.required.$invalid && errors.push(this.$t('register.steps.whitelabel.form.subdomain.errors.required'));
            return errors;
        },
        primaryColorErrors() {
            const errors = [];
            if (!this.v$.form.config.primaryColor.$dirty)
                return errors;
            this.v$.form.config.primaryColor.required.$invalid && errors.push(this.$t('register.steps.whitelabel.form.primary_color.errors.required'));
            return errors;
        },
        secondaryColorErrors() {
            const errors = [];
            if (!this.v$.form.config.secondaryColor.$dirty)
                return errors;
            this.v$.form.config.secondaryColor.required.$invalid && errors.push(this.$t('register.steps.whitelabel.form.secondary_color.errors.required'));
            return errors;
        },
        textColorErrors() {
            const errors = [];
            if (!this.v$.form.config.textColor.$dirty)
                return errors;
            this.v$.form.config.textColor.required.$invalid && errors.push(this.$t('register.steps.whitelabel.form.text_color.errors.required'));
            return errors;
        }
    },
    watch: {
        country: {
            immediate: true,
            handler() {
                this.showPhone = false;
                console.log("reseting phone...");
                this.form.phone = "";
            }
        },
        'form.subdomain': {
          handler(val){
            if(val.length >= 6 && val.length <= 20)
            this.checkSubdomain()
            else this.subdomainNotAvailable = false
          }
        }
    },
    methods: {
      uploadLogo() {
          const logoForm = {
                    paths:['publishers','mediaVendors',moment().format('x')],
                    file: this.imgPreview,
                     name: this.getImgName
                    
                }

            this.$axios({
                method: "post",
                url: `content/general`,
                data: logoForm,
              
            }).then((response) => {
               // this.$emit("set-upload", response.data.data[0]);
                this.loading = false;
                this.completed = true
                console.log('resp: ',response)
              
            })
                .catch(function (response) {
                    //handle error
                    console.error(response);
                });
        },

        addLink(){
          this.form.links.push({"url": "", "text": "", "id": moment().format('X')})
        },
        remLink(i){
          this.loadingLink = true
          setTimeout(() => {
            this.form.links.splice(i, 1)
            this.loadingLink = false
          },100)
        },  
        prevent(event) {
            event.stopPropagation();
        },
        checkSubdomain(){
          this.processingSubdomain = true
          const Form = {
            input: "subdomain",
            value: this.form.subdomain
          }
          this.$axios.post(`assets/checker/subdomain`, Form).then(() => {
            this.subdomainNotAvailable = false
            this.processingSubdomain = false        
          }, () => {
            this.subdomainNotAvailable = true
            this.processingSubdomain = false
          });
        },
        
        submit() {
            this.processing = true;
            this.v$.$touch();
            if (!this.v$.$invalid) {
                const Form = { 
                  "hash" : this.hash,
                  "country" : this.assets.countries[this.country].name, 
                  "referer": "whitelabel",	
                  "subdomain":this.form.subdomain,
                  "logo": this.form.logo,
                  //"links":this.form.links,
                 // "primaryColor": this.form.config.primaryColor,
                 // "secondaryColor": this.form.config.secondaryColor,
                 // "textColor": this.form.config.textColor,
                  //"banner": this.form.banner,
                  "update": true
              }
              this.$axios.post(`portal/register/finish?hash=${this.hash}`, Form).then((response) => {
                    console.log('response', response.data.data.hash)
                    this.$emit("set-hash", { hash: this.hash, interaction: "publisher.confirmlegal" });
                    this.processing = false
              },
              (err) => {
                    const error =  err.response.data.errors
                    if(error.length && error[0].hasOwnProperty('timeout')){
                        this.$emit('set-generic-error', 'register.token.expired')
                    }
                    else{
                        console.error('An error found', error)
                    }
                    this.processing = false
                })
            }
            else {
                this.processing = false;
            }
        }
    },
    // components: { RegisterAddress }
}
</script>
<style>

.imgOK .uploadWrapper{
  display:none
}

.uploadWrapper .border[data-v-428b0bc4] {
    border: 2px dashed #ccc;
    height: 100%;
    width: 100%;
  
}


.theme--light.v-input.-red--text input, .theme--light.v-input.-red--text textarea{
  color: #ff5252 !important;
}
.--preview-logo-upload .v-image__image--cover{
  background-size: contain !important;
}
</style>